(() => {
  'use strict';
  if (customElements.get('complementary-products')) return;
  customElements.define('complementary-products', class extends HTMLElement {
    connectedCallback() {
      this.variantModes = JSON.parse(this.dataset.charmVariants || '{}');
      this.handleVariantChange = this.onVariantChange.bind(this);
      if (this.dataset.charmVariants) document.addEventListener('theme:variant:change', this.handleVariantChange);
      this.observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        this.observer.unobserve(this);
        if (!this.getAttribute('data-url')) return;
        fetch(this.getAttribute('data-url'))
          .then(response => response.text())
          .then(html => {
            if (!this.isConnected) return;
            const document = new DOMParser().parseFromString(html, 'text/html');
            const content = document.querySelector('complementary-products');
            if (!content || !content.innerHTML.trim()) return;
            this.originalHtml = content.innerHTML;
            this.renderContents();
          })
          .catch(error => console.error(error));
      }, {rootMargin: '0px 0px 400px 0px'});
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('theme:variant:change', this.handleVariantChange);
    }
    onVariantChange(event) {
      const mode = this.variantModes[String(event.detail?.variant?.id)];
      if (!mode || mode === this.dataset.charmMode) return;
      this.dataset.charmMode = mode;
      if (this.originalHtml) this.renderContents();
    }
    renderContents() {
      const template = document.createElement('template');
      template.innerHTML = this.originalHtml;
      if (this.dataset.charmMode === 'large') {
        template.content.querySelectorAll('quick-add-product').forEach(card => {
          if (card.dataset.charmRingSize === 'Klein') card.remove();
        });
      }
      this.replaceChildren(template.content);
      if (this.hasAttribute('data-slider')) {
        this.dispatchEvent(new CustomEvent('theme:complementary:loaded', {bubbles: true, detail: {container: this}}));
      }
    }
  });
})();
